export const colourHash = {
    0: "#053B50",
    1: "#D2DE32",
    2: "#C08261",
    3: "#4B527E",
}

const sizes = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    tabletS: '600px',
    tablet: '768px',
    laptop: '1024px',
    laptopL: '1440px',
    desktop: '2560px',
  };
  

  export const device = {
    mobileS: `(max-width: ${sizes.mobileS})`,
    mobileM: `(max-width: ${sizes.mobileM})`,
    mobileL: `(max-width: ${sizes.mobileL})`,
    tabletS: `(max-width: ${sizes.tabletS})`,
    tablet: `(max-width: ${sizes.tablet})`,
    laptop: `(max-width: ${sizes.laptop})`,
    laptopL: `(max-width: ${sizes.laptopL})`,
    desktop: `(max-width: ${sizes.desktop})`,
  };
  
  export const ResumeLink = "https://drive.google.com/file/d/1Hw3zEMcb3YDbzXEVJiLHkVL1p8MZkUMK/view?usp=sharing";
